<!------------ START TEMPLATE ------------>
<template>
  <Modal
    class="holamundo"
    :title="title"
    :active.sync="exibeModal"
    @close="closeModal"
  >
    <form role="form" @submit.stop.prevent="onSubmit">
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <span ref="mybtn">Beneficio</span>
          <v-select
            :options="beneficios"
            name="Beneficio"
            id="Beneficio"
            v-model="formCadastro.beneficio"
            v-validate="{ required: true }"
            :state="validateState('Beneficio')"
            :class="validateClass('Beneficio')"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-2">
          <vs-button
            @click="adicionaTodos = false"
            color="success"
            class="mb-2 my-5"
          >
            <span>Adicionar</span>
          </vs-button>
        </div>
        <div class="vx-col sm:w-1/4 w-full mb-2">
          <vs-button
            @click="adicionaTodos = true"
            color="dark"
            class="mb-2 my-5"
          >
            <span>Adicionar Todos</span>
          </vs-button>
        </div>
      </div>
    </form>
    <vs-table :data="valoresBeneficios" noDataText="Nenhum Benefício Vinculado">
      <template slot="thead">
        <vs-th>Benefício</vs-th>
        <vs-th></vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td
            class="vx-col sm:w-1/3 w-full mb-2"
            :data="data[indextr].nome"
            >{{ data[indextr].nome }}</vs-td
          >

          <vs-td
            class="vx-col sm:w-1/3 w-full mb-2"
            :data="data[indextr].idTabelaValorBeneficio"
          >
            <vs-button
              @click="
                deletaBeneficioVinculado(data[indextr].idTabelaValorBeneficio)
              "
              radius
              color="danger"
              type="gradient"
              icon="clear"
              class="d-inline"
            ></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </Modal>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import moment from 'moment';
import jwt from 'jsonwebtoken';
import BotaoSubmit from './../../components/BotaoSubmit';
import vSelect from 'vue-select';
import service from '../../services';
import { VMoney } from 'v-money';
import Modal from '../../components/Modal.vue';

export default {
  props: ['modalSelecionado', 'popupActive', 'title', 'dados'],
  watch: {
    popupActive: function (newValue, oldValue) {
      this.exibeModal = newValue;
    },
    modalSelecionado: function (newValue, oldValue) {
      this.formCadastro = {
        idTabelaValor: newValue.idTabelaValor,
        produto: null,
        valor: '',
      };
      this.idTabelaValor = newValue.idTabelaValor;
      this.getBeneficios(newValue.idGrupo);
      this.getvaloresBeneficios(newValue.idTabelaValor);
    },
  },
  directives: { money: VMoney },
  data() {
    return {
      idTabelaValor: null,
      valorTotal: 0,
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      beneficios: [],
      valoresBeneficios: [],
      aguardeCadastro: false,
      exibeModal: false,
      adicionaTodos: false,
      formCadastro: {
        idTabelaValor: null,
        beneficio: null,
        beneficios: [],
      },
    };
  },
  methods: {
    salvaDescricaoVinculada(idTabelaValorBeneficio) {
      var model = this.valoresBeneficios.filter(
        (x) => x.idTabelaValorBeneficio == idTabelaValorBeneficio,
      );
      this.$vs.loading();
      service
        .post('TabelaValoresBeneficios', 'Atualizar', model[0])
        .then((res) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Operação Realizada com sucesso`,
            color: 'success',
          });
          this.getvaloresBeneficios(this.idTabelaValor);
          this.$refs.mybtn.click();
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
    deletaBeneficioVinculado(idTabelaValorBeneficio) {
      var ids = [];
      this.$vs.loading();
      ids.push(idTabelaValorBeneficio);
      service
        .post('TabelaValoresBeneficios', 'Inativar', { ids: ids })
        .then((res) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Benefício desvinculado com sucesso',
            color: 'success',
          });
          this.$vs.loading.close();
          let array = this.valoresBeneficios;
          for (var i = array.length - 1; i >= 0; i--) {
            if (array[i].idTabelaValorBeneficio == idTabelaValorBeneficio) {
              array.splice(i, 1);
            }
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    getvaloresBeneficios(id) {
      this.valoresBeneficios = [];
      this.$vs.loading();
      service
        .getAll('TabelaValoresBeneficios', {}, 'list/' + id)
        .then((res) => {
          this.valoresBeneficios = [];
          res.data.forEach((element) => {
            element.nome = element.TabelaBeneficios_Beneficios.nome;
            this.valoresBeneficios.push(element);
          });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    getBeneficios(idGrupo) {
      this.beneficios = [];
      const token = localStorage.getItem('user-token');
      var idEmpresa = null;
      if (token) {
        const decoded = jwt.decode(token);
        idEmpresa = decoded.id_empresa;
      }
      service.getAll('Beneficios', {}, 'list/' + idEmpresa).then((res) => {
        res.data.forEach((element) => {
          var tipo = element.Beneficios_domTipoBeneficio.nomeTipo;
          if (element.deletedAt == null)
            this.beneficios.push({
              id: element.idBeneficio,
              label: tipo + ' - ' + element.nome,
            });
        });
      });
    },
    onSubmit() {
      var action = 'Adicionar';
      var msgRetorno = `Registro Adicionado com sucesso`;
      if (this.adicionaTodos == false) {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.aguardeCadastro = true;
          this.$vs.loading();
          this.formCadastro.insertAll = false;
          this.formCadastro.beneficios = [];
          service
            .post('TabelaValoresBeneficios', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.getvaloresBeneficios(this.idTabelaValor);
              this.$vs.loading.close();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        });
      } else {
        this.aguardeCadastro = true;
        this.$vs.loading();
        this.formCadastro.insertAll = true;
        this.formCadastro.beneficios = this.beneficios;
        this.formCadastro.valoresBeneficios = this.valoresBeneficios;
        service
          .post('TabelaValoresBeneficios', action, this.formCadastro)
          .then((res) => {
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Operação Realizada com sucesso`,
              color: 'success',
            });
            this.getvaloresBeneficios(this.idTabelaValor);
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: error,
              color: 'danger',
            });
          });
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    closeModal() {
      this.$emit('close');
    },
    formataData(data) {
      // formats data received from API
      var formattedData = moment(data).format('DD/MM/YYYY');
      return formattedData;
    },
    formataTexto(texto) {
      if (texto == true) return 'sim';
      if (texto == false) return 'não';
      return texto;
    },
  },
  mounted() {},
  components: {
    BotaoSubmit,
    vSelect,
    Modal
  },
};
</script>
<!------------ END SCRIPT ------------>
